<div class="circle-container">
  @for (i of [].constructor(5); track $index) {
    <div class="dot"></div>
  }
</div>
